import { Component } from '@angular/core'

@Component({
  selector: 'app-application-settings-tabs',
  standalone: false,
  template: `
    <div class="content-block light-control-host">
      <router-outlet></router-outlet>
    </div>
  `,
})
export class ApplicationSettingsTabsComponent {
  // This is a simple wrapper component for future extensibility
  // All logic stays in ApplicationEditorComponent for now
}
